import React from 'react';
import { FlaskConical } from 'lucide-react';
import { useExperience } from '../experience/experience';

/**
 * The sandbox banner: shown to everyone, on every screen, while the selected organisation is a sandbox (the
 * experience's `sandbox`, from organizations.is_demo; backend/sandbox.py). A sandbox holds test data the operator can
 * reset, so nobody should mistake it for the client's real organisation. A real organisation shows nothing.
 */
export const SANDBOX_TEXT = 'Sandbox: test data, can be reset';

export default function SandboxBanner() {
  const exp = useExperience();
  if (exp?.sandbox !== true) return null;
  return (
    <div role="status" data-testid="sandbox-banner"
      className="flex items-center justify-center gap-2 px-4 py-1.5 text-sm font-semibold text-white bg-orange-600
        bg-[repeating-linear-gradient(135deg,rgba(0,0,0,0.12)_0_12px,transparent_12px_24px)]">
      <FlaskConical className="w-4 h-4" aria-hidden="true" />
      <span>{SANDBOX_TEXT}</span>
    </div>
  );
}
